export enum MediaPlayerState {
  NOT_INIT = 'not_init',
  ENDED = 'ended',
  ERROR = 'error',
  PLAYING = 'playing',
  PAUSE = 'pause',
  LOADING = 'loading',
}
